import { readConfigHomeHomeHistory } from '@racepointenergy/swc/scs/read-config-home-home-history'

import { StyledConfigHeader } from '../styles'

import { useAppSelector } from 'app/hooks'
import { TableLoader } from 'components/Table'

import { useHomeRouteParams } from '../../../hooks'
import { selectedHomeSelector } from '../../../selectors'
import { HomeDeploymentsHistoryTable } from '../..'
import { WhiteBlock } from 'components/Layout'

const moduleInitialized = Date.now()

function selectFromResult(
  queryResult: Parameters<
    NonNullable<
      NonNullable<
        Parameters<typeof readConfigHomeHomeHistory['useQuery']>[1]
      >['selectFromResult']
    >
  >[0]
): Parameters<
  NonNullable<
    NonNullable<
      Parameters<typeof readConfigHomeHomeHistory['useQuery']>[1]
    >['selectFromResult']
  >
>[0] {
  if (queryResult.data !== undefined) {
    return {
      ...queryResult,
      data: {
        ids: queryResult.data.ids.filter((entityId) => {
          const entity = queryResult.data?.entities[entityId]
          return (
            entity?.state !== 'NEW' || entity.date + 600000 > moduleInitialized
          )
        }),
        entities: queryResult.data.entities,
      },
    }
  }
  return queryResult
}

function HomeDeploymentsHistory() {
  const { homeId } = useHomeRouteParams()
  const selectedHome = useAppSelector(selectedHomeSelector.data)
  const {
    data: homeConfigHistory,
    isError,
    isLoading,
    isSuccess,
    isUninitialized,
  } = readConfigHomeHomeHistory.useQuery(
    { homeId },
    {
      pollingInterval: 10000,
      selectFromResult,
    }
  )

  return (
    <>
      <StyledConfigHeader>
        <h2>Deployment History</h2>
      </StyledConfigHeader>

      {(isLoading || isUninitialized) && <TableLoader />}

      {isError && (
        <WhiteBlock bigPadding>
          You do not have permission to access this feature.
          <br />
          Please contact your Savant Central Management administer for
          permission.
        </WhiteBlock>
      )}

      {isSuccess && (homeConfigHistory?.ids?.length ?? 0) === 0 && (
        <WhiteBlock bigPadding>
          No deployment history available yet. <br />
          If you deploy a configuration to <strong>{selectedHome?.name}</strong>
          , you will see it here.
        </WhiteBlock>
      )}

      {isSuccess && (homeConfigHistory?.ids?.length ?? 0) > 0 && (
        <>
          <HomeDeploymentsHistoryTable data={homeConfigHistory!} />
        </>
      )}
    </>
  )
}

export default HomeDeploymentsHistory
